export default __webpack_public_path__ + "static/media/alert_red.6e70bc44.png";